export default {
    ocupado: false,
    error: "",
    user: null,
    token: null,
    instrucciones: null,
    itemsFiltrados: [],
    empresa: null,
    empresas: [],
}